/**
 * SoftPlan public Web3D gallery examples for the site planner.
 * Origin: softplan (not Construx product SKUs).
 * Generated by tools/softplan-web3d/convert-softplan-examples.js
 * Source: https://softplan.com/web3d/web3d.php
 * Docs: docs/SOFTPLAN_WEB3D_CONVERSION.md
 *
 * Catalog rule (docs/MODEL_ASSETS.md): only list slugs whose GLBs are
 * uploaded to the Blob store — un-hosted entries 404 in production.
 * Local-only conversions (e.g. sp-42186, sp-43783) stay out until uploaded
 * via tools/softplan-web3d/upload-models-blob.mjs.
 */

export const SOFTPLAN_EXAMPLES_CATALOG = [
  {
    "slug": "sp-11637",
    "label": "Jonathan Hermann",
    "title": "Jonathan Hermann",
    "publisher": "Jeremy Martin",
    "softPlanId": "11637",
    "token": "6127dc0b03297af13bc33bc9f64e17bc",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=11637&c=6127dc0b03297af13bc33bc9f64e17bc"
  },
  {
    "slug": "sp-37901",
    "label": "James & Charlene Brubacher Custom H…",
    "title": "James & Charlene Brubacher Custom Home",
    "publisher": "Jeremy Martin",
    "softPlanId": "37901",
    "token": "f99b445fc9ff0a3f7f590f9f2c5cfa28",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=37901&c=f99b445fc9ff0a3f7f590f9f2c5cfa28"
  },
  {
    "slug": "sp-39489",
    "label": "Philip Vanderkruk",
    "title": "Philip Vanderkruk",
    "publisher": "Jeremy Martin",
    "softPlanId": "39489",
    "token": "e5992ac7d9e5d0460d68550e018c8ba2",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=39489&c=e5992ac7d9e5d0460d68550e018c8ba2"
  },
  {
    "slug": "sp-40064",
    "label": "WUEBKER, JEFF",
    "title": "WUEBKER, JEFF",
    "publisher": "Katie Delzeith",
    "softPlanId": "40064",
    "token": "240008ee6b9c2357a06063e2467d1159",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=40064&c=240008ee6b9c2357a06063e2467d1159"
  },
  {
    "slug": "sp-40762",
    "label": "12x16 Atrium-12x14 Victorian-10x10 …",
    "title": "12x16 Atrium-12x14 Victorian-10x10 Atrium Combo (LSNH-Knox)",
    "publisher": "John Huyard",
    "softPlanId": "40762",
    "token": "e9558f2e53dc21d002b43b89a54914f7",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=40762&c=e9558f2e53dc21d002b43b89a54914f7"
  },
  {
    "slug": "sp-41601",
    "label": "Gary & Leanne Jantzi Custom Home",
    "title": "Gary & Leanne Jantzi Custom Home",
    "publisher": "Jeremy Martin",
    "softPlanId": "41601",
    "token": "e249bcecd6d971c5104831e7da11c2ce",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=41601&c=e249bcecd6d971c5104831e7da11c2ce"
  },
  {
    "slug": "sp-41610",
    "label": "STEVE & TONYA ACCARDO",
    "title": "STEVE & TONYA ACCARDO",
    "publisher": "Kenneth Maye",
    "softPlanId": "41610",
    "token": "9833441925bdb8c48424da2932254049",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=41610&c=9833441925bdb8c48424da2932254049"
  },
  {
    "slug": "sp-41774",
    "label": "20x30 Two Story Garage (AS-PO# 7562)",
    "title": "20x30 Two Story Garage (AS-PO# 7562)",
    "publisher": "John Huyard",
    "softPlanId": "41774",
    "token": "f3ac5293cab1c1f78fe87599ad60bf67",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=41774&c=f3ac5293cab1c1f78fe87599ad60bf67"
  },
  {
    "slug": "sp-42051",
    "label": "SHEPHERD, JONATHAN",
    "title": "SHEPHERD, JONATHAN",
    "publisher": "Katie Delzeith",
    "softPlanId": "42051",
    "token": "25b000d2a9d9a0322c194ae41f40445f",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=42051&c=25b000d2a9d9a0322c194ae41f40445f"
  },
  {
    "slug": "sp-42098",
    "label": "SOLL, ERIK",
    "title": "SOLL, ERIK",
    "publisher": "Jessica Borgelt",
    "softPlanId": "42098",
    "token": "31aded6362f712c987f7bec79fb7a1e5",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=42098&c=31aded6362f712c987f7bec79fb7a1e5"
  },
  {
    "slug": "sp-42606",
    "label": "RANDOLPH, COURTNEY",
    "title": "RANDOLPH, COURTNEY",
    "publisher": "Katie Delzeith",
    "softPlanId": "42606",
    "token": "b77b37cd03306fe3c6c077c66067d624",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=42606&c=b77b37cd03306fe3c6c077c66067d624"
  },
  {
    "slug": "sp-42804",
    "label": "3623 WELLSPRING LAKE DR",
    "title": "3623 WELLSPRING LAKE DR",
    "publisher": "Jacob Brown",
    "softPlanId": "42804",
    "token": "2f007989ccd75f2fba3200de38d45f16",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=42804&c=2f007989ccd75f2fba3200de38d45f16"
  },
  {
    "slug": "sp-42888",
    "label": "SCHOENLEIN, RICK",
    "title": "SCHOENLEIN, RICK",
    "publisher": "Katie Delzeith",
    "softPlanId": "42888",
    "token": "cc465c491fb7c1e3ee1a9b6dfb1479e4",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=42888&c=cc465c491fb7c1e3ee1a9b6dfb1479e4"
  },
  {
    "slug": "sp-43013",
    "label": "Sagamore - Tanner plan",
    "title": "Sagamore - Tanner plan",
    "publisher": "Eric Johnson",
    "softPlanId": "43013",
    "token": "f56b7427cdfc50af4d2c4e821f43e9f3",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=43013&c=f56b7427cdfc50af4d2c4e821f43e9f3"
  },
  {
    "slug": "sp-43195",
    "label": "Laverne & Loretta Frey Addition",
    "title": "Laverne & Loretta Frey Addition",
    "publisher": "Andrew Martin / Star Blueprints",
    "softPlanId": "43195",
    "token": "1a43aec5f2eb7681876547c190a69bdb",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=43195&c=1a43aec5f2eb7681876547c190a69bdb"
  },
  {
    "slug": "sp-43231",
    "label": "JONES, ROBBIE & LAUREN",
    "title": "JONES, ROBBIE & LAUREN",
    "publisher": "Katie Delzeith",
    "softPlanId": "43231",
    "token": "0d0d972b1a72ee1aee0fd9f46dfb9179",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=43231&c=0d0d972b1a72ee1aee0fd9f46dfb9179"
  },
  {
    "slug": "sp-43284",
    "label": "14x20 Garden Shed w Dormer & Alpine…",
    "title": "14x20 Garden Shed w Dormer & Alpine OH (LSS-Mumau)",
    "publisher": "John Huyard",
    "softPlanId": "43284",
    "token": "170489503c2938286a9c9c6030b596f4",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=43284&c=170489503c2938286a9c9c6030b596f4"
  },
  {
    "slug": "sp-43580",
    "label": "3604 Steve Knutson Res. Acc. Buildi…",
    "title": "3604 Steve Knutson Res. Acc. Building",
    "publisher": "Andrew Martin / Star Blueprints",
    "softPlanId": "43580",
    "token": "1460270750333a64d8e2c1798ffc9f95",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=43580&c=1460270750333a64d8e2c1798ffc9f95"
  },
  {
    "slug": "sp-43863",
    "label": "28'2''x42'8'' Two Story Gambrel Gar…",
    "title": "28'2''x42'8'' Two Story Gambrel Garage w Dormers (LSL-Rizvi)",
    "publisher": "John Huyard",
    "softPlanId": "43863",
    "token": "f128f678a1bdf46ebf066facd802a455",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=43863&c=f128f678a1bdf46ebf066facd802a455"
  },
  {
    "slug": "sp-43892",
    "label": "36x36 Two Story Garden Shed Garage …",
    "title": "36x36 Two Story Garden Shed Garage w Dormer (LSB-Case)",
    "publisher": "John Huyard",
    "softPlanId": "43892",
    "token": "538dae3c071728ba9804dc575514aac7",
    "origin": "softplan",
    "displayUrl": "https://softplan.com/web3d/display_model.php?id=43892&c=538dae3c071728ba9804dc575514aac7"
  }
];

export function softplanExampleEntry(slug) {
  return SOFTPLAN_EXAMPLES_CATALOG.find((m) => m.slug === slug) || null;
}
